import Navigation from "@/components/sections/Navigation";
import Hero from "@/components/sections/Hero";
import ProblemRecognition from "@/components/sections/ProblemRecognition";
import IndustryShowcase from "@/components/sections/IndustryShowcase";
import HowItWorks from "@/components/sections/HowItWorks";
import VerticalBenefits from "@/components/sections/VerticalBenefits";
import TransformationProof from "@/components/sections/TransformationProof";
import TechnologyPreview from "@/components/sections/TechnologyPreview";
import CTASection from "@/components/sections/CTASection";
import Footer from "@/components/sections/Footer";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { GeoRedirect } from '@/components/GeoRedirect';
import { HomeGridSection, Navbar } from "@/components";
import { useEffect } from 'react';
import { useTranslation } from 'next-i18next';
import SEO from '@/components/SEO';

export async function getServerSideProps({ locale }: any) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'home',
      ])),
      // Will be passed to the page component as props
    },
  }
}

export default function Home() {
  const { t } = useTranslation('home');

  // Track mouse position for light effect animations
  useEffect(() => {
    const handleMouseMove = (e: MouseEvent) => {
      document.documentElement.style.setProperty('--x', e.clientX.toString());
      document.documentElement.style.setProperty('--y', e.clientY.toString());
    };

    document.addEventListener('mousemove', handleMouseMove);

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return (
    <>
      <GeoRedirect />
      <SEO
        title={t('meta.title')}
        description={t('meta.description')}
        ogImage="/images/og-home.png"
      />
      <div className="min-h-screen">
        <Navbar />
        <Hero />
        <ProblemRecognition />
        <VerticalBenefits />
        <HowItWorks />
        <IndustryShowcase />
        <TransformationProof />
        {/* Keep this commented until we have content to put here */}
        {/* <TechnologyPreview /> */}
        <CTASection />
        <Footer />
      </div>
    </>
  );
}
